export const PropertyGroups: Record<
  string,
  // A group that opens a new section of the add-filter menu sits below a divider.
  { title: string; startsSection?: boolean }
> = {
  primary: {
    title: 'Properties',
  },
  classifications: {
    title: 'Classifications',
  },
  'backup-details': {
    title: 'Backup details',
  },
  'restore-details': {
    title: 'Restore details',
  },
  'source-location': {
    title: 'Source location',
  },
  'backup-from': {
    title: 'Backup from',
  },
  'backup-to': {
    title: 'Backup to',
  },
  'restore-from': {
    title: 'Restore from',
  },
  'restore-to': {
    title: 'Restore to',
  },
  'sync-from': {
    title: 'Sync from',
  },
  'sync-to': {
    title: 'Sync to',
  },
  'threat-detection': {
    title: 'Threat detection',
    startsSection: true,
  },
  'posture-issues': {
    title: 'Posture issues',
  },
};
